import * as React from 'react';
import { GetSettings } from '../../../functions/StateManagement/StateStorageFunctions';
import { DashboardOrganizer, DefaultPageSettings } from '../../../functions/WidgetDashboardOrganizer';
import { TechnologyTeamDashboardProps, TechnologyTeamDashboardState } from './TechnologyTeamDashboard.constants';
import KnowledgebaseCreationWidget from '../../TicketingSystemComponents/TicketWidgets/KnowledgebaseCreationWidget';
import { RenderSettings } from '../../../interfaces/WidgetSettingsInterfaces';
import TicketSummaryLookupWidget from '../../TicketingSystemComponents/TicketWidgets/TicketSummaryLookupWidget';
import DashboardHeaderRow from '../../CoreComponents/DashboardHeaderRow';

export default class TechnologyTeamDashboard extends React.Component<TechnologyTeamDashboardProps, TechnologyTeamDashboardState> {

  settingsString: string = "techTicketDashboard";

  constructor(props: TechnologyTeamDashboardProps) {
    super(props);
    let settings: RenderSettings = GetSettings<RenderSettings>(this.settingsString);
    let showModal: boolean = false;
    if (settings === null) {
      settings = DefaultPageSettings
    }
    this.state = {
      showModal: showModal,
      renderSettings: settings,
      displayWidgets: [],
      widgetList: []
    }
    DashboardOrganizer.bind(this);
  }

  async componentDidMount(): Promise<void> {
    await this.prepareDasboard();
  }

  async prepareDasboard(): Promise<void> {
    let displayWidgets: { [key: number]: JSX.Element } = {
      0: <KnowledgebaseCreationWidget />,
      1: <TicketSummaryLookupWidget />
    };
    let widgetList = [
      { label: "KB Article Creation", value: "0" },
      { label: "Ticket Summary Lookup", value: "1"}
    ]
    this.setState({
      displayWidgets: displayWidgets,
      widgetList: widgetList
    })
  }

  updateUI = (settings: RenderSettings): void => {
    this.setState({ renderSettings: settings })
  }

  render(): JSX.Element {
    return (
      <>
        <DashboardHeaderRow
          dashboardTitle={"Tech Dashboard"}
          settingsString={this.settingsString}
          displayList={this.state.displayWidgets}
          widgetList={this.state.widgetList}
          updateUI={this.updateUI}
        />
        {DashboardOrganizer(this.state.displayWidgets, this.state.renderSettings)}
      </>
    )
  }
}